import { render, staticRenderFns } from "./TemporaryLocker.vue?vue&type=template&id=48906424&"
import script from "./TemporaryLocker.vue?vue&type=script&lang=js&"
export * from "./TemporaryLocker.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryLocker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TemporaryLocker.vue"
export default component.exports